var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.601,
    height: 142.601,
    viewBox: "0 0 142.601 142.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_chart",
    "data-name": "vuesax/outline/chart",
    transform: "translate(-444 250.601) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(108 444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.873,127.746A63.927,63.927,0,0,1,0,63.873c0-14.022,12.893-38.5,12.893-38.5l7.13,5.407S8.913,51.812,8.913,63.873a54.961,54.961,0,0,0,109.921,0c0-30.3-54.961-54.961-54.961-54.961V0s63.873,28.639,63.873,63.873A63.927,63.927,0,0,1,63.873,127.746Z",
    transform: "translate(7.427 7.427)",
    fill: "#f29a38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M46.048,92.1C20.677,92.1,0,46.048,0,46.048H8.913S25.549,83.184,46.048,83.184A37.149,37.149,0,0,0,83.184,46.048c0-20.5-37.136-37.136-37.136-37.136V0S92.1,20.677,92.1,46.048A46.126,46.126,0,0,1,46.048,92.1Z",
    transform: "translate(25.252 25.252)",
    fill: "#f29a38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.456,56.446V47.534s19.31-8.675,19.31-19.31S4.456,8.913,4.456,8.913V0S32.679,12.656,32.679,28.223,4.456,56.446,4.456,56.446Z",
    transform: "translate(66.844 43.077)",
    fill: "#f29a38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H142.6V142.6H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/Circle.155b0254e6021d51697cada75f423dfd.svg";
export { ForwardRef as ReactComponent };